import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function WillsPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['wills']} />;
}
